import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=6350895a"
import script from "./excel.vue?vue&type=script&lang=js"
export * from "./excel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports